import API from './api';

const migrarArquivoLegadoParaS3 = (codppcArquivo, cpfCnpj) => {
  const response = API.post(
    `${process.env.REACT_APP_API_CADASTRO_BASE_URL}/documentos/link-legado-para-s3`,
    {
      codppcArquivo,
      cpfCnpj
    }
  );
  return response;
};

export default migrarArquivoLegadoParaS3;
